module.exports = __webpack_public_path__ + "img/call-icon-alt.2e798312.svg";